import { IColumn, ColumnActionsMode } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { DocumentTextRegular, EditRegular } from '@fluentui/react-icons';
import React from 'react';
import { iconButtonStyles, rowClasses } from '../../../../app/common/styles/CommonStyleObjects';
import { IMilestoneTemplate } from '../../../../utils/types/IMilestoneTemplate';
import CanAccess from '../../../common/canAccess/CanAccess';

const getMilestoneTemplateColumns = (
  setCurrentMilestone: React.Dispatch<React.SetStateAction<IMilestoneTemplate>>,
  setIsEditPanelOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDetailsPanelOpen: React.Dispatch<React.SetStateAction<boolean>>,
): IColumn[] => {
  const columns: IColumn[] = [
    {
      key: 'name',
      name: 'Name',
      fieldName: 'name',
      minWidth: 175,
      maxWidth: 350,
      isRowHeader: false,
      data: 'string',
      isPadded: true,
      isMultiline: true,
      className: rowClasses.medFont,
      columnActionsMode: ColumnActionsMode.disabled,
    },
  ];

  columns.push({
    key: 'milestoneCategoryName',
    name: 'Category',
    fieldName: 'milestoneCategoryName',
    minWidth: 175,
    maxWidth: 350,
    isRowHeader: false,
    data: 'string',
    isPadded: true,
    isMultiline: true,
    className: rowClasses.medFont,
    columnActionsMode: ColumnActionsMode.disabled,
  });

  columns.push({
    key: 'id',
    name: 'Actions',
    fieldName: 'id',
    minWidth: 175,
    maxWidth: 350,
    isRowHeader: false,
    data: 'string',
    isPadded: true,
    isMultiline: true,
    className: rowClasses.medFont,
    columnActionsMode: ColumnActionsMode.disabled,
    onRender: (item: IMilestoneTemplate): JSX.Element => (
      <>
        <Button
          appearance="transparent"
          icon={<DocumentTextRegular color={iconButtonStyles.color} />}
          onClick={() => {
            setCurrentMilestone(item);
            setIsDetailsPanelOpen(true);
          }}
        >
          Milestone Details
        </Button>
        <CanAccess requestedAction="MilestoneTemplate:Edit">
          <Button
            appearance="transparent"
            icon={<EditRegular color={iconButtonStyles.color} />}
            onClick={() => {
              setCurrentMilestone(item);
              setIsEditPanelOpen(true);
            }}
          >
            Edit Milestone
          </Button>
        </CanAccess>
      </>
    ),
  });

  return columns;
};

export default getMilestoneTemplateColumns;
